import { BlockError } from '@/blocks.04-project/block-error/block-error';
import { LazyInit } from '@/blocks.04-project/lazy-init/lazy-init';

/***
 * Класс
 */
class WaitingCollapse {
  /***
   * Конструктор класса
   * @param elem {HTMLElement} DOM элемент с классом waiting-collapse
   * @param force {Boolean|undefined} принудительно инициализирование
   */
  constructor({ elem, force }) {
    this.BlockError = new BlockError({ blockName: 'WaitingCollapse', destroy: this.destroy });
    if (!elem) return this.BlockError.error('Отсутствует elem');

    this.block = elem;
    this.block.WaitingCollapse = this;
    this.block.AsyncWaitingCollapse = new Promise((resolve) => {
      this.promiseResolve = resolve;
    }).then((ins) => ins);

    this.LazyInit = new LazyInit({ ins: this, callback: this.init, addClass: 'waiting-collapse_inited' });
    this.LazyInit.init();
    if (force) this.LazyInit.earlyInit();
  }

  init = async () => {
    this.collapseSelector = this.block.dataset['bsTarget'] || false;
    if (!this.collapseSelector) return this.BlockError.error(' отсутствует data-bs-target');

    this.collapse = document.querySelector(this.collapseSelector);
    if (!this.collapse) return this.BlockError.error('collapse target не найден');

    this.collapse.addEventListener('hide.bs.collapse', this.add);
    this.collapse.addEventListener('hidden.bs.collapse', this.remove);

    this.collapse.addEventListener('show.bs.collapse', this.add);
    this.collapse.addEventListener('shown.bs.collapse', this.remove);

    this.promiseResolve(this);
    this.block.AsyncWaitingCollapse = this;
  };

  add = () => this.block.classList.add('disabled');

  remove = () => this.block.classList.remove('disabled', true);

  destroy = () => {
    if (this.LazyInit) this.LazyInit.destroy();
    if (this.collapse) {
      this.collapse.removeEventListener('hide.bs.collapse', this.add);
      this.collapse.removeEventListener('hidden.bs.collapse', this.remove);
      this.collapse.removeEventListener('show.bs.collapse', this.add);
      this.collapse.removeEventListener('shown.bs.collapse', this.remove);
    }
    if (this.block) {
      this.remove();
      this.block.classList.remove('waiting-collapse_inited');
      delete this.block.WaitingCollapse;
      delete this.block.AsyncWaitingCollapse;
    }
  };

  static init({ container = document, force = false } = {}) {
    Array.from(container.querySelectorAll('.waiting-collapse:not(.waiting-collapse_inited)')).forEach((elem) => new WaitingCollapse({ elem, force }));
  }
}

document.addEventListener('DOMContentLoaded', () => WaitingCollapse.init(), { once: true });

// Экспорт;
window.Block.WaitingCollapse = WaitingCollapse;
